import React from 'react';
import { FileCheck, ShieldCheck, MessageSquare, ArrowRight } from 'lucide-react';
export function ProductReveal() {
  return <section className="bg-[#FDF8EE] py-20 px-4 sm:px-6" data-id="element-153">
      <div className="max-w-6xl mx-auto" data-id="element-154">
        {/* Reveal Header */}
        <div className="text-center mb-16" data-id="element-155">
          <span className="text-[#C9A84C] font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-156">
            Presentamos
          </span>
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-[#1B2A4A] mb-6" data-id="element-157">
            Carpeta de Alquiler Imposible (España)
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-158">
            Un sistema en PDF + plantillas para que tengas una candidatura
            ordenada, comprensible y difícil de ignorar.
          </p>
        </div>

        {/* The 3C System Breakdown */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-159">
          {/* C1: Credibilidad */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-[#1B2A4A] hover:shadow-xl transition-shadow" data-id="element-160">
            <div className="w-14 h-14 bg-[#1B2A4A] rounded-xl flex items-center justify-center mb-6 text-white shadow-lg shadow-blue-900/20" data-id="element-161">
              <ShieldCheck className="w-8 h-8" data-id="element-162" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-[#1B2A4A] mb-4" data-id="element-163">
              1. Credibilidad
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-164">
              No basta con tener papeles. Tienen que estar en el orden correcto,
              con nombres limpios y en un PDF maestro.
            </p>
            <ul className="space-y-2 text-sm text-gray-700" data-id="element-165">
              <li className="flex items-center gap-2" data-id="element-166">
                <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full" data-id="element-167"></div>
                Orden psicológico correcto
              </li>
              <li className="flex items-center gap-2" data-id="element-168">
                <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full" data-id="element-169"></div>
                Resumen ejecutivo de 1 página
              </li>
              <li className="flex items-center gap-2" data-id="element-170">
                <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full" data-id="element-171"></div>
                Elimina la necesidad de llamadas
              </li>
            </ul>
          </div>

          {/* C2: Claridad */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-[#C9A84C] relative transform lg:-translate-y-4 z-10 hover:shadow-xl transition-shadow" data-id="element-172">
            <div className="absolute top-0 right-0 bg-[#C9A84C] text-[#1B2A4A] text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-173">
              CLAVE DEL SISTEMA
            </div>
            <div className="w-14 h-14 bg-[#C9A84C] rounded-xl flex items-center justify-center mb-6 text-[#1B2A4A] shadow-lg shadow-yellow-500/20" data-id="element-174">
              <FileCheck className="w-8 h-8" data-id="element-175" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-[#1B2A4A] mb-4" data-id="element-176">
              2. Claridad
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-177">
              Tu nómina puede ser correcta, pero si tu situación no se entiende
              rápido, te descartan por precaución.
            </p>
            <ul className="space-y-2 text-sm text-gray-700" data-id="element-178">
              <li className="flex items-center gap-2" data-id="element-179">
                <div className="w-1.5 h-1.5 bg-[#1B2A4A] rounded-full" data-id="element-180"></div>
                Historia financiera en 6 líneas
              </li>
              <li className="flex items-center gap-2" data-id="element-181">
                <div className="w-1.5 h-1.5 bg-[#1B2A4A] rounded-full" data-id="element-182"></div>
                Responde objeciones antes de que existan
              </li>
              <li className="flex items-center gap-2" data-id="element-183">
                <div className="w-1.5 h-1.5 bg-[#1B2A4A] rounded-full" data-id="element-184"></div>
                No suena a excusa ni a "por favor"
              </li>
            </ul>
          </div>

          {/* C3: Cierre */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-[#1B2A4A] hover:shadow-xl transition-shadow" data-id="element-185">
            <div className="w-14 h-14 bg-[#1B2A4A] rounded-xl flex items-center justify-center mb-6 text-white shadow-lg shadow-blue-900/20" data-id="element-186">
              <MessageSquare className="w-8 h-8" data-id="element-187" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-[#1B2A4A] mb-4" data-id="element-188">
              3. Cierre
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-189">
              La mayoría hace la visita y espera. Eso es regalar la decisión.
              Profesionaliza tu seguimiento.
            </p>
            <ul className="space-y-2 text-sm text-gray-700" data-id="element-190">
              <li className="flex items-center gap-2" data-id="element-191">
                <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full" data-id="element-192"></div>
                Guion de visita estratégico
              </li>
              <li className="flex items-center gap-2" data-id="element-193">
                <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full" data-id="element-194"></div>
                Mensajes post-visita (copy/paste)
              </li>
              <li className="flex items-center gap-2" data-id="element-195">
                <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full" data-id="element-196"></div>
                Mini-fecha de decisión sin presión
              </li>
            </ul>
          </div>
        </div>

        {/* Special Cases Section */}
        <div className="bg-[#1B2A4A] rounded-2xl p-8 sm:p-12 text-center text-white relative overflow-hidden" data-id="element-197">
          <div className="relative z-10" data-id="element-198">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold mb-4" data-id="element-199">
              "¿Y si soy extranjero, autónomo, tengo contrato nuevo o pago con
              ahorros?"
            </h3>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto text-lg" data-id="element-200">
              Perfecto. Por eso existe el capítulo de casos especiales. El
              problema no es tu caso, es que tal como lo presentas ahora, parece
              incierto. Aquí lo conviertes en algo legible y manejable.
            </p>
            <a href="#pricing" className="inline-flex items-center gap-2 text-[#C9A84C] font-bold hover:text-white transition-colors" data-id="element-201">
              Ver lo que incluye <ArrowRight className="w-5 h-5" data-id="element-202" />
            </a>
          </div>
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#C9A84C_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-203"></div>
        </div>
      </div>
    </section>;
}